import { Avatar, Radio } from "@material-ui/core";
import Rating from "@material-ui/lab/Rating";
import React from "react";
import { S3baseUrl } from "../../../../../bl_libs/ApiCalling";

function UserCard(props) {
  const { customerDetails, HitCompanyActivate, HitCompanyDeactivate } = props;

  const {
    profile_picture,
    first_name,
    last_name,
    email,
    phone,
    customer_rating,
    is_active,
  } = customerDetails;
  return (
    <>
      <div className="form-group text-center pt-4">
        {
          //if preview is empty show default
          profile_picture ? (
            //if profile picture is available show profile
            <img
              src={S3baseUrl + profile_picture}
              className="circle-box rounded-circle edit-profile-img"
            />
          ) : (
            //else show default picture
            <Avatar
              style={{
                width: 150,
                height: 150,
                fontSize: 22,
                marginLeft: "auto",
                marginRight: "auto",
              }}
            ></Avatar>
          )
        }
        <div className="pt-3">
          <Rating
            value={customer_rating ? customer_rating : 0}
            readOnly
            precision={0.1}
          />
        </div>
      </div>
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">Name:</div>
        <div className="col-7 text-left black-color">
          {first_name + " " + last_name}
        </div>
      </div>
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">Email:</div>
        <div className="col-7 text-left black-color">{email}</div>
      </div>
      <div className="row small-font-size pl-4 pt-2">
        <div className="col-5 text-left dark-grey-color">Phone:</div>
        <div className="col-7 text-left black-color">{phone}</div>
      </div>
      <div className="row small-font-size pl-4 pt-2 pb-4">
        <div className="col-5 text-left dark-grey-color pt-2">Status:</div>
        <div className="col-7 ">
          {is_active ? (
            <>
              <div style={{ minWidth: 100 }}>
                <Radio checked style={{ color: "green", marginLeft: -15 }} />
                Active
              </div>
            </>
          ) : (
            <>
              <div style={{ minWidth: 100 }}>
                <Radio checked color="secondary" style={{ marginLeft: -15 }} />
                Inactive
              </div>
            </>
          )}
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="text-center status-buttons pb-40 text-center">
          {is_active ? (
            <span
              onClick={HitCompanyDeactivate}
              className="custom-btn-small custom-button-extra-small req-status-button filter-button req-cancelled active"
            >
              Deactive Customer
            </span>
          ) : (
            <span
              onClick={HitCompanyActivate}
              className="custom-btn-small custom-button-extra-small req-status-button filter-button req-done mt-2 mt-sm-0 active"
            >
              Active Customer
            </span>
          )}
        </div>
      </div>
    </>
  );
}

export default UserCard;
